function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var RewardsFilled = function RewardsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M18.468 4.62c-.012-1.067-.43-2.075-1.119-2.696C15.991.7 13.905.692 12.496 1.906a5 5 0 0 0-.618.648 4 4 0 0 0-.263-.247c-1.305-1.125-3.238-1.12-4.498.018-.64.578-1.029 1.512-1.039 2.499-.004.449.094.996.435 1.57H3.5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1H11v.006h2v-.005h7.5a1 1 0 0 0 1-1v-15a1 1 0 0 0-1-1h-2.553c.41-.65.526-1.27.521-1.775M13 23.395V6.4h-2v16.995zM8.078 4.843c.004-.423.153-.83.378-1.033.505-.456 1.319-.451 1.853.012.209.18.403.42.578.712q.05.084.113.154v1.706l-1.593.001c-.629-.36-1.335-.908-1.329-1.552m5.06-.602c.198-.335.423-.612.665-.82.635-.548 1.605-.553 2.207-.01.272.245.452.728.458 1.23.007.727-.723 1.339-1.418 1.754H13V4.452l.03-.045.014-.02z",
    clipRule: "evenodd"
  }));
};
export default RewardsFilled;